import React from 'react'

// Hooks
import { useSearch } from 'modules/shares/hooks/useSearch'

// Components
import { Grid, Text } from '@sketch/components'
import { Section } from '@sketch/discover'

// Local Components
import CommunityHeader from '../../components/CommunityHeader'
import CommunityWrapper from '../../components/CommunityWrapper'
import EditorialItem from '../../components/EditorialItem'

// Styles
import { Description, Header, Title, Search } from './Community.styles'

// Types
import { InitialUserFragment, GetCommunityQuery } from '@sketch/gql-types'

interface CommunityPops {
  user: Pick<InitialUserFragment, 'name' | 'avatar'> | undefined
  data: GetCommunityQuery
}

const Community: React.FC<CommunityPops> = ({ user, data }) => {
  const { search, setSearch } = useSearch()

  const sections = data?.community.sections ?? []

  return (
    <>
      <CommunityHeader user={user} />
      <CommunityWrapper>
        <Header>
          <Title>
            <Text textStyle="header.primary.I">Community Canvas</Text>
            <Description>
              Explore our curated collection of freely-available resources, made
              with love by Sketch and the community.
            </Description>
          </Title>

          <Search
            onChange={setSearch}
            value={search}
            name="search"
            placeholder="Search resources..."
          />
        </Header>
        <Grid>
          {sections.map(section => (
            <Section
              key={section.id}
              context={'COMMUNITY'}
              itemComponent={EditorialItem}
              {...section}
            />
          ))}
        </Grid>
      </CommunityWrapper>
    </>
  )
}

export default Community
